module.exports = __webpack_public_path__ + "img/9788983946782.bd262f6f.jpg";